import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentTitle,
  content,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Discovery & Analysis"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedonedev}
          contentTitle="Discovery & Analysis"
          content="Identify business needs and technical requirements through in-depth consultations. Analyze current systems and processes to pinpoint areas for improvement."
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Feasibility & Impact Assessment"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedtwodev}
          contentTitle="Feasibility & Impact Assessment"
          content="Evaluate technical feasibility and potential impact on business operations. Provide detailed cost and timeline estimates based on comprehensive analysis."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="Solution Architecture Design"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedthreedev}
          contentTitle="Solution Architecture Design"
          content="Develop a robust, scalable architecture tailored to your business needs. Ensure seamless integration with existing systems and future scalability."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Technology Selection & Prototyping"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedfourdev}
          contentTitle="Technology Selection & Prototyping"
          content="Select the most suitable technologies and create prototypes. Validate design choices and gather stakeholder feedback for iterative improvements."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Agile Development Process"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedfivedev}
          contentTitle="Agile Development Process"
          content="Implement solutions using Agile methodologies. Ensure continuous integration, testing, and delivery for high-quality, reliable outputs."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        <AccordionItem
          title="System Integration & Testing"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedsixdev}
          contentTitle="System Integration & Testing"
          content="Integrate new solutions with existing infrastructure. Conduct thorough testing to ensure functionality, performance, and security."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        />
        <AccordionItem
          title="Deployment & User Training"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Deployment & User Training"
          content="Deploy the solution across the organization. Provide comprehensive training to ensure smooth adoption and maximize user efficiency."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        />
        <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        />
      </div>
    </section>
  );
}

export default DiscoveryAcc;
